import { Edit } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { editSuggestionProduct } from '../../api/products';
import useAuthToken from '../../hooks/getUserData';
import Modal from '../elements/Modal';
import ProductForm from './ProductForm';

export default function EditProduct({
  product,
  fetchData,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [productData, setProductData] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const token = useAuthToken();

  useEffect(() => {
    setProductData({ ...product });
  }, [product]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  const handleEditForm = async (values) => {
    const payload = {
      ...values,
      title: values.title,
      url: values.productUrl,
      price: values.providerPrice,
      providerId: values.providerId,
      auto_suggestion_id: values.auto_suggestion_id,
      ...(values.primaryImage && { primaryImage: values.primaryImage }),
      ...(values.secondaryImage && { secondaryImage: values.secondaryImage }),
    };
    setLoading(true);
    try {
      const response = await editSuggestionProduct(payload, product.id, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Product updated successfully');
      fetchData();
      handleClose();
    } catch (error) {
      setError(
        error.message || 'An error occurred while updating product data.'
      );
    }
    setLoading(false);
  };

  return (
    <>
      <IconButton
        variant="text"
        onClick={handleClickOpen}
        sx={{ p: 2 }}
        size="small"
        title="Edit product">
        <Edit />
      </IconButton>
      <Modal
        open={open}
        width={'sm'}
        modalTitle="Edit Product"
        handleClose={handleClose}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <ProductForm
          product={productData}
          onSubmit={handleEditForm}
          token={token}
          loading={loading}
        />
      </Modal>
    </>
  );
}
